import Avatar from "../../others/Avatar";
import React from "react";
import { ChevronDown } from "lucide-react";

interface ProfileButtonProps {
  avatar: string | null;
  onClick?: () => void;
  username?: string;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({
  avatar,
  onClick,
  username,
}) => {
  return (
    <button
      onClick={onClick}
      className="group flex px-3 py-2 cursor-pointer sm:gap-3 items-center sm:bg-gradient-to-b sm:from-gray-800/60 sm:to-gray-900/60 p-2.5 rounded-full sm:border sm:border-gray-700/50 sm:hover:border-red-500/30 sm:shadow-md transition-all duration-300 justify-center"
    >
      <Avatar
        src={avatar ?? undefined}
        children={undefined}
        sizeClass="w-8 h-8"
        className="transition-transform group-hover:scale-105"
      />
      <div className="flex items-center gap-1">
        {username && (
          <>
            <span className="text-white font-medium text-sm hidden sm:block">
              {username}
            </span>
            <ChevronDown
              size={16}
              className="text-white opacity-70 hidden sm:block transition-transform group-hover:translate-y-0.5"
            />
          </>
        )}
      </div>
    </button>
  );
};

export default ProfileButton;
